import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChainLink1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chain-link-1,url"><path d="M13.25 17.75L9.5 21.5L2.5 14.5L6.25 10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 6.25L14.5 2.5L21.5 9.5L17.75 13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 15L15 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
};

export default IconChainLink1;
